export const ACTION_TYPES = {
    UPDATE_LOCATION: '@@location_picker/UPDATE_LOCATION',
};

export const updateLocation = latLng => ({
    type: ACTION_TYPES.UPDATE_LOCATION,
    location: latLng,
});
